module.exports = __webpack_public_path__ + "img/n.666b6f24.jpg";